module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "camp-fire-background.74dc3ffe.jpg";